import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { CommandMenu, CommandMenuProvider } from "@/components/CommandMenu";
import { CommentsPage } from "@/features/comments/routes/CommentsPage";
import { NavStackProvider } from "@/utils/useNavStack";

export const Route = createLazyFileRoute("/_auth/_app/comments/")({
  component: memo(CommentsRoot),
});

function CommentsRoot() {
  return (
    <NavStackProvider label="Comments" href={{ to: "/comments" }}>
      <CommentsPage />

      <CommandMenuProvider>
        <CommandMenu />
      </CommandMenuProvider>
    </NavStackProvider>
  );
}
